import React  from "react";
import { FormatMessage } from "react-globalize";
import { getListItems } from "../globalizationUtils";

export default function SectionTerms(props)
{
  let locale = props.locale || 'en';  

  return (
  <div id = "terms">
    <div className="title">
      <h3><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/title" /></h3>
    </div>
    <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/FRAUD_ALERT"/></p>
    <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/escrow"/></p>
    <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/credentialsNotification"/></p>
    <ol>
      <li id="terms1">
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/1/line" elements={{bold:<strong></strong>}}/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/1/info"/></p>
        <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/1/listTitle"/><br/>
        <ol>
          {getListItems(locale, 4, "quisqueyanaPolicy/terms/1/feeConditionList" )}
        </ol>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/1/note"/></p>
      </li>
      <li id="terms2"><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/2/title" />:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/2/info" elements={{bold:<strong></strong>}}/></li>
      <li id="terms3"><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/3/title" />:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/3/info" elements={{bold:<strong></strong>}}/></li>
      <li id="terms4"><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/4/title" />:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/4/info" elements={{bold:<strong></strong>}}/></li>
      <li id="terms5">
        <p><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/5/title"/>:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/5/line" elements={{bold:<strong></strong>}}/>
        </p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/5/info"/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/5/RESTRICTIONS" elements={{bold:<strong></strong>}}/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/5/EXCEPTIONS_N_ARBITRATION" elements={{bold:<strong></strong>}}/></p>
        <p><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/5/SEVERABILITY" elements={{bold:<strong></strong>}}/></p>
      </li>
      <li id="terms6">
        <p><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/6/title"/>:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/6/info" elements={{bold:<strong></strong>}}/></p>
        <p>
          <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/6/footNote/title"/><br/>
          <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/6/footNote/california" elements={{bold:<strong></strong>}}/>
        </p>
      </li>
      <li id="terms7"><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/7/title"/>:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/7/info"  elements={{bold:<strong></strong>}}/></li>
      <li id="terms8"><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/8/title" />:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/8/info"  elements={{bold:<strong></strong>}}/></li>
      <li id="terms9">
        <strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/9/title" />:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/9/info" elements={{bold:<strong></strong>}}/><br/>
        <ol>
          {getListItems(locale, 3, "quisqueyanaPolicy/terms/9/list", {bold:<strong></strong>, br:<p></p>})}
        </ol>
      </li>
      <li id="terms10">
        <strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/10/title"/>:</strong>
        <ul>
          {getListItems(locale, 4, "quisqueyanaPolicy/terms/10/usesList", {bold:<strong></strong>})}
        </ul>
      </li>
      <li id="terms11"><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/11/title"/>:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/11/info" elements={{bold:<strong></strong>, phone: <a className="strong" href="tel:+1- 866- 271- 3202"></a>}}/></li>
      <li id="terms12"><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/12/title"/>:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/12/info" elements={{bold:<strong></strong>}}/></li>
      <li id="terms13"><strong><FormatMessage locale={locale} path="quisqueyanaPolicy/terms/13/title"/>:</strong> <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/13/info" elements={{bold:<strong></strong>}}/></li>
    </ol>
    <p>
      <FormatMessage locale={locale} path="quisqueyanaPolicy/terms/date"/>
    </p>

  </div>
  )
}


// WEBPACK FOOTER //
// ./js/SectionQuisqueyanaPolicy/SectionTerms/SectionTerms.js